import React from "react";
import { Spin, Select } from "antd";

import { compose, config } from "src/helpers";
import { Field, RenderSelect } from "src/components";

import { withQuestions } from "src/modules/question/operations";

import { withStateAndActionsForQuestion } from "../resolvers";

const Option = Select.Option;

const SubjectsField = (props) => {
    const { loading, questions, where, onNameChange, onChange, value } = props;

    return (
        <Field
            labelInValue
            showSearch={true}
            filterOption={false}
            onSearch={onNameChange}
            notFoundContent={loading ? <Spin size="small" /> : null}
            name={"questions"}
            component={RenderSelect}
            placeholder={"Questions"}
            label={"Questions"}
            value={value || "None"}
            loading={loading}
            onChange={onChange}
            inFilter={true}
            noBotMarging={true}
        >
            {[
                // config.EMPTY_OPTION,
                ...(questions?.map((question) => ({
                    id: question.id,
                    label: question.name || "",
                    value: JSON.stringify(question),
                })) || []),
            ]?.map(
                ({
                    id,
                    value,
                    label = "",
                }: {
                    id: string;
                    value: string;
                    label: string;
                }) => (
                    <Option key={id} value={value}>
                        {label}
                    </Option>
                ),
            )}
        </Field>
    );
};

export default compose(
    withStateAndActionsForQuestion,
    withQuestions,
)(SubjectsField);
